import { Conditional } from '@resurs/react-utils'
import React from 'react'
import PropTypes from 'prop-types'

const HelpText = ({ children }) => (
  <>
    {children.split('\n').map(
      (
        text,
        key /* eslint-disable
    react/no-array-index-key */,
      ) => (
        <p key={`${key}`} style={{ color: '#666', lineHeight: '1.25em' }}>
          <Conditional.Group>
            <Conditional when={key === 0}>
              <strong>{text.split(' ')[0]}</strong>{' '}
              {text.substring(text.indexOf(' '))}
            </Conditional>
            <Conditional.NoMatch>{text}</Conditional.NoMatch>
          </Conditional.Group>
        </p>
        /* eslint-enable react/no-array-index-key */
      ),
    )}
  </>
)

HelpText.propTypes = {
  children: PropTypes.string.isRequired,
}

export default HelpText
